import { gql } from "@apollo/client";

export const GET_IMPRIMIR_CONFORMIDADES = gql`
query GetImprimirConformidades($evaluaciones: [ImprimirConformidadFilterInput!]!) {
  imprimirConformidades(evaluaciones: $evaluaciones) {
    success
    error
    valorEsperado
  }
}
  `;
